import { DateTime } from "luxon";

export function isServiceItemOrderable({
  bookingFrom,
  bookingStart,
  setUpTime,
  bookingLeadTime,
  maxSetupTime,
  isServiceAdminBypass = false
}: {
  bookingFrom: string | null;
  bookingStart: string | null;
  setUpTime: number; // minutes
  bookingLeadTime: number; // hours
  maxSetupTime: number; // minutes
  /** When true, skips booking-lead-time and setup-time checks (service admin). */
  isServiceAdminBypass?: boolean;
}): boolean {
  if (!bookingFrom || !bookingStart) return false;

  const bookingDateTime = DateTime.fromISO(`${bookingFrom}T${bookingStart}`);
  if (!bookingDateTime.isValid) return false;

  // Service admin may order outside minimum booking lead time and outside setup-time rules
  // (max setup duration and setup time vs. minutes until the booking starts).
  if (isServiceAdminBypass) {
    return true;
  }

  const hoursUntilBooking = bookingDateTime.diffNow().as("hours");
  const minutesUntilBooking = bookingDateTime.diffNow().as("minutes");

  const leadTimeValid = hoursUntilBooking > bookingLeadTime;
  const setupTimeValidByMaxSetupTime = setUpTime <= maxSetupTime;
  const setupTimeValidByBookingStart = setUpTime <= minutesUntilBooking;

  return leadTimeValid && setupTimeValidByMaxSetupTime && setupTimeValidByBookingStart;
}
